import { Box, DialogContent } from '@mui/material';
import { LocaleText } from '../../../locale';
import React from 'react';
import { PreviewContainer } from './PreviewContainer';
import { styles } from './PreviewModalDialogContent.styles';

export interface PreviewModalDialogContentProps {
  localeText: LocaleText;
  options: React.ReactElement;
  previewLink: string;
  previewCount: number;
  showPdfLoadingSpinner: boolean;
  unavailableMessage?: string;
}

export const PreviewModalDialogContent: React.FC<PreviewModalDialogContentProps> = ({
  localeText,
  options,
  previewLink,
  previewCount,
  showPdfLoadingSpinner,
  unavailableMessage
}) => {
  return (
    <DialogContent sx={styles.dialogContent}>
      <Box sx={styles.container}>
        <Box sx={styles.formContainer}>{options}</Box>
        <PreviewContainer
          previewSrc={previewLink}
          showInitialSpinner={previewCount === 0}
          showSpinner={previewCount > 0 && !!previewLink && showPdfLoadingSpinner}
          showCompleted={previewCount > 1 && !!previewLink && !showPdfLoadingSpinner}
          completedLabel={localeText.exportPdfModal.completedLabel}
          spinnerLabel={localeText.exportPdfModal.previewUpdatingLabel}
          previewTitle={localeText.exportPdfModal.previewTitle}
          unavailableMessage={unavailableMessage}
        />
      </Box>
    </DialogContent>
  );
};
